import { AbstractControl, FormControl } from '@angular/forms';
import { ConfirmedValidator } from 'validators/password-strength.validator';
import { IFormBuilder } from '../IFormBuilder';
import { GenericBaryFormGroup, IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { UserTypeEnum } from '../../enums/user-type.enum';

export type RestrictedBaryUserControls = { [key: string]: AbstractControl } & {
  civility: FormControl;
  firstName: FormControl;
  lastName: FormControl;
  phone: FormControl;
  email: FormControl;
  dateBirth: FormControl;
  position: FormControl;
};

export type BaryUserControls = { [key: string]: AbstractControl } & {
  civility: FormControl;
  firstName: FormControl;
  lastName: FormControl;
  phone: FormControl;
  email: FormControl;
  password: FormControl;
  confirmPassword: FormControl;
  userType: FormControl;
  cgv: FormControl;
  dateBirth: FormControl;
  isTemporalPassword: FormControl;
  position: FormControl;
};

interface IBaryUserFormBuilder<T> extends IFormBuilder<BaryUserControls | RestrictedBaryUserControls> {
  init(baryUserType: UserTypeEnum): IBaryUserFormBuilder<T>;

  isRestricted(): IBaryUserFormBuilder<T>;

  build(): IGenericBaryFormGroup<BaryUserControls | RestrictedBaryUserControls>;
}

export class BaryUserFormBuilder<T extends { [key: string]: AbstractControl }> implements IBaryUserFormBuilder<T> {
  private formName = 'userForm';
  private restricted = false;
  private controls: BaryUserControls | any = {};

  constructor(private bcf: BaryFormFactoryService) {}

  init(baryUserType: UserTypeEnum): BaryUserFormBuilder<T> {
    this.controls = this.bcf.makeBaryUserControls(baryUserType);
    return this;
  }

  isRestricted(): BaryUserFormBuilder<T> {
    delete this.controls?.password;
    delete this.controls?.confirmPassword;
    delete this.controls?.baryUserType;
    delete this.controls?.cgv;
    this.restricted = true;
    return this;
  }

  build(): IGenericBaryFormGroup<BaryUserControls | RestrictedBaryUserControls> {
    if (this.restricted) {
      return new GenericBaryFormGroup(this.formName, this.controls as RestrictedBaryUserControls);
    } else {
      return new GenericBaryFormGroup(this.formName, this.controls as BaryUserControls, [ConfirmedValidator('password', 'confirmPassword')]);
    }
  }
}
